/**
 * Semantic status colors per mode.
 *
 * These pin MUI's own light/dark defaults so adopting the token palette does
 * not shift existing status visuals; they exist as tokens so every surface
 * (and later the Tailwind preset / emails) shares one source of truth.
 *
 * Dark-mode contrast on navy900 (#1a1c29), WCAG AA ≥ 4.5:1 required:
 *   error   #f44336  4.59:1
 *   warning #ffa726  8.70:1
 *   info    #29b6f6  7.34:1
 *   success #66bb6a  7.15:1
 */
export const statusLight = {
  error: { main: "#d32f2f" },
  warning: { main: "#ed6c02" },
  info: { main: "#0288d1" },
  success: { main: "#2e7d32" },
} as const;

export const statusDark = {
  error: { main: "#f44336" },
  warning: { main: "#ffa726" },
  info: { main: "#29b6f6" },
  success: { main: "#66bb6a" },
} as const;

/**
 * "Awaiting input" treatment for HITL jobs/reports. Values are pinned by
 * tests (awaitingInputStyles.test.ts) and shared by chips, banners, and the
 * job tracker:
 *   main  — the base yellow surface/badge color
 *   light — dark-mode accent (text on tinted surfaces)
 *   dark  — light-mode accent (text on tinted surfaces)
 */
export const awaitingInput = {
  main: "#FFD600",
  light: "#FFE082",
  dark: "#8D5B00",
  contrastText: "rgba(0, 0, 0, 0.87)",
} as const;
